<template>
        <!-- initial questions -->
        <LcForm v-if="!shouldProceedWithFlow"
            :formData="this.formData.initial"
            v-model:application-settings="this.applicationSettings"
            @completed.once="this.userSelectedOption = true"
        />
        <!-- registered state -->
        <LcForm v-if="showRegisteredStateFlow && shouldProceedWithFlow"
            :formData="this.formData.registered"
            :showSkipRegistration="true"
            v-model:application-settings="this.applicationSettings"
            @completed.once="this.completedRegisteredState()"
        />
        <!-- unregistered state -->
        <LcForm v-if="!showRegisteredStateFlow && shouldProceedWithFlow"
            :formData="this.formData.unregistered"
            :formSettings="this.formSettings"
            v-model:application-settings="this.applicationSettings"
            @completed.once="this.completedUnegisteredState()"
        />
        <!-- TODO -- change this to show a way to create a password reset -->
        <!-- <div v-if="showPasswordResetStep">
            <a href="#" class="">Seems like you already have an account with LC, if you forgot your password click here.</a>
        </div> -->
</template>

<script>

import LcForm from '@/components/form/LcForm.vue';

import formSteps from '@/form/steps/registration.js';
import formStepsRegistered from '@/form/steps/registered.js';
import formStepsUnregistered from '@/form/steps/unregistered.js';

export default {
    name: 'RegistrationFlow',
    emits: ["update:application-settings","update:component-settings"],
    components: {
        LcForm,
    },
    props: {
        applicationSettings: {
            type: Object,
            required: true,
        },
        componentSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {

        let userSelectedOption = false;

        // different form steps for different scenarios, check out the imports for this component
        const formData = {
            initial: {
                steps: formSteps
            },
            registered: {
                steps: formStepsRegistered
            },
            unregistered: {
                steps: formStepsUnregistered
            },
        };

        const formSettings = {
            submitButtonText: 'Submit'
        };

        return {
            formData,
            formSettings,
            userSelectedOption
        };
    },
    methods: {
        completedRegisteredState() {
            this.isUserRegistered = true;
            this.componentSettings.isCompleted = true;
            this.applicationSettings.isUserAuthenticated = true;
        },
        completedUnegisteredState() {
            this.isUserRegistered = false;
            this.componentSettings.isCompleted = true;
            this.applicationSettings.isUserAuthenticated = false;
        }
    },
    computed: {
        showRegisteredStateFlow() {
            return !!this.applicationSettings.userWantsRegistration || 
            (!!this.applicationSettings.isUserRegistered && !!this.applicationSettings.isUserAuthenticated);
        },
        // showPasswordResetStep() {
        //     return !!this.applicationSettings.isUserRegistered && !this.applicationSettings.isUserAuthenticated && this.applicationSettings.userAuthenticationAttempts > 0;
        // },
        isComponentVisible() {
            return !!this.componentSettings.isVisible; 
        },
        shouldProceedWithFlow() {
            return this.applicationSettings.isUserAuthenticated || this.userSelectedOption; 
        },
    },
    created() {
        // console.log('RegistrationFlow created');
    },
    mounted() {
        // console.log('RegistrationFlow mounted')
    },
    watch: {
    }  

};
</script>